export const DEFAULT_STRUCTURE_PREDICTION_MODEL = 'boltz2';
export const LEGACY_DEFAULT_STRUCTURE_PREDICTION_MODEL = 'alphafold';
export const DEFAULT_GENERATIVE_MODEL = 'boltzgen';

export const MAX_BULK_PREDICTION_ITEMS = 100;
export const MAX_MULTIMER_COMPONENTS = 25;

export const MSA_SUPPORT = {
  NONE: 'NONE',
  OPTIONAL: 'OPTIONAL',
  REQUIRED: 'REQUIRED',
} as const;

export enum ScientificModelPreferences {
  HAS_DISMISSED_MODEL_CONFIDENCE_POPOVER = 'HAS_DISMISSED_MODEL_CONFIDENCE_POPOVER',
  LAST_SELECTED_STRUCTURE_PREDICTION_MODEL = 'LAST_SELECTED_STRUCTURE_PREDICTION_MODEL',
}
